module.exports = __webpack_public_path__ + "img/16d001-16.5462dbbd.png";